import {
    IAdminCompanyFullInfo,
    IAdminPanelCompanyUseCase,
    ICompanyPaymentCreateDto,
    ICompanyPayment,
    ICompany,
    IReadQuery,
    ISelectedData,
    ICompanyPricingPlanDto,
    ICompanyPricing,
} from "@lib";
import { QueryConverter } from "@/utils/plugins/query-converter";
import { DataLoadException } from "@/core/exceptions";
import { Api } from "../axios";

export class AdminPanelCompanyUseCase implements IAdminPanelCompanyUseCase {
    public async select(query?: IReadQuery): Promise<ISelectedData<ICompany>> {
        try {
            const params = QueryConverter.objectToQuery(query);
            const response = await Api.get<ISelectedData<ICompany>>("/admin/companies", { params });
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async get(companyId: string): Promise<IAdminCompanyFullInfo> {
        try {
            const response = await Api.get<IAdminCompanyFullInfo>(`/admin/companies/${companyId}`);
            return response.data;
        } catch (e) {
            throw new DataLoadException(e);
        }
    }

    public async delete(companyId: string): Promise<void> {
        try {
            await Api.delete<void>(`/admin/companies/${companyId}`);
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async payment(companyId: string, dto: ICompanyPaymentCreateDto): Promise<ICompanyPayment> {
        try {
            const response = await Api.post<ICompanyPayment>(`/admin/companies/${companyId}/payments`, dto);
            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }

    public async changePricePlan(companyId: string, dto: ICompanyPricingPlanDto): Promise<ICompanyPricing> {
        try {
            const response = await Api.patch<ICompanyPricing>(`/admin/companies/${companyId}/price-plan`, dto);
            return response.data;
        } catch (e) {
            throw new DataLoadException(e);
        }
    }

    public async export(query?: IReadQuery): Promise<Blob> {
        try {
            const params = QueryConverter.objectToQuery(query);
            const response = await Api.get<Blob>(`/admin/companies/actions/export`, {
                params,
                responseType: "blob",
            });

            return response.data;
        } catch (e: any) {
            throw new DataLoadException(e);
        }
    }
}
